import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {
  ComponentLifetimeEndEventName,
  ComponentLifetimeStartEventName,
  trackTotalLifetime,
} from 'common/util/component-helpers';
import {LoadingType} from 'common/util/workflow-timing';

import {SkeletonListAttrs, SkeletonListJsxProps, SkeletonListRowSize} from './types';
import {template} from './template';
import css from './index.inline.styl';

export class SkeletonList extends Component<SkeletonListAttrs> {
  static get attrsSchema(): AttrsSchema<SkeletonListAttrs> {
    return {
      ...super.attrsSchema,
      'row-size': {type: `string`, enum: Object.values(SkeletonListRowSize), default: SkeletonListRowSize.Medium},
      'num-rows': {type: `number`, default: 8},
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
      useShadowDom: true,
    });
  }

  connectedCallback() {
    super.connectedCallback();
    trackTotalLifetime(this, {
      eventNames: {
        start: ComponentLifetimeStartEventName.LoadingAdded,
        end: ComponentLifetimeEndEventName.LoadingDisplayed,
      },
      props: {type: LoadingType.Skeleton},
    });
  }
}

export const SkeletonListEl = defineAndMakeJsxFactory<SkeletonListJsxProps>(`mp-skeleton-list`, SkeletonList);
export const SkeletonListReact = panel2react<SkeletonListJsxProps>(`mp-skeleton-list`, SkeletonList);
